<template>
    <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div class="text-center">
            <p class="text-base font-semibold text-rose-600">404</p>
            <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Aucune page de trouvée</h1>
            <div class="mt-10 flex items-center justify-center gap-x-6">
                <router-link :to="{name: 'Dashboard'}" href="#"
                    class="rounded-md bg-rose-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-rose-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-600">Retour au tableau de bord.</router-link>
            </div>
        </div>
    </main>
</template>